import React from "react";
import EmployeeDetailHeader from "./component/employee-detail-header";
import {IEmployeeDetail} from "../../domains/models/employee";
import {IFileState} from "./types/employee-details.types";
import EmployeeDetailTabs from "./component/employee-detail-tabs";

interface employeeDetailsViewProps {
    viewState: { isModalVisible: boolean; popoverVisible: boolean };
    isActiveEmployee: boolean;
    navigateToDocument: () => void;
    getInitials: (e: IEmployeeDetail | null) => string;
    employeeData: IEmployeeDetail | null;
    navigateToEmployeeEdit: () => void;
    user: any;
    setViewState: React.Dispatch<React.SetStateAction<{ isModalVisible: boolean; popoverVisible: boolean }>>;
    PopoverMenuItems: any[];
    profileState: IFileState;
}

const EmployeeDetailView = (props: employeeDetailsViewProps) => {
    return (
        <>
            <div className='employee-detail'>
                <EmployeeDetailHeader viewState={props.viewState}
                                      setViewState={props.setViewState}
                                      navigateToDocument={props.navigateToDocument}
                                      isActiveEmployee={props.isActiveEmployee}
                                      getInitials={props.getInitials}
                                      PopoverMenuItems={props.PopoverMenuItems}
                                      profileState={props.profileState}
                                      employeeData={props.employeeData}
                                      navigateToEmployeeEdit={props.navigateToEmployeeEdit}
                                      user={props.user}
                />

                <EmployeeDetailTabs employeeData={props.employeeData}
                                    profileState={props.profileState}
                                    getInitials={props.getInitials}/>

            </div>
        </>
    )
}

export default EmployeeDetailView;